// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicInformation_basic-information__WRrm\\+ {
  display: flex;
  align-items: center;
  align-self: stretch;
  background-color: #f8f8f8;
  flex-direction: column;
}
.BasicInformation_basic-information__right__uzFfa {
  width: 100%;
  padding: 54px 16px 32px;
  position: relative;
  background-color: var(--background-color-2);
  gap: 4px;
}
.BasicInformation_basic-information__right__uzFfa .BasicInformation_images-seal-wrapper__nfXxR {
  overflow: hidden;
  position: absolute;
  top: 0;
  transform: translateY(-84px);
  padding: 2px;
  border-radius: 9999px;
  border: none;
  background-color: var(--background-color-2);
}
.BasicInformation_basic-information__left__OFtMI {
  align-self: stretch;
}
.BasicInformation_basic-information__left__OFtMI .BasicInformation_cover-img-wrapper__ul7qv {
  height: 280px;
  width: 100%;
}
.BasicInformation_basic-information__left__OFtMI .BasicInformation_cover-img-wrapper__ul7qv img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_images-seal-wrapper__nfXxR {
  padding: 8px;
  border-radius: 8px;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_images-seal-wrapper__nfXxR .BasicInformation_images-seal__wTit\\+ {
  width: 119px;
  height: 118px;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_name__7yLH7 {
  width: fit-content;
  color: var(--accent-color-dark);
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_sub-name__neZ2V {
  color: var(--dark-grey);
  font-size: 14px;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_sub-name__neZ2V:hover {
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_bio__o5J-X {
  margin-top: 10px;
  color: var(--dark-grey);
  font-size: 14px;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_bio--content__Nx0Rb {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
}
.BasicInformation_basic-information__WRrm\\+ .BasicInformation_more-info__ZabQu {
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

@media only screen and (max-width: 900px) {
  .BasicInformation_basic-information__right__uzFfa {
    padding: 54px 16px 16px;
  }
  .BasicInformation_basic-information__right__uzFfa .BasicInformation_name__7yLH7 {
    font-size: 18px;
  }
  .BasicInformation_basic-information__right__uzFfa .BasicInformation_sub-name__neZ2V {
    font-size: 12px;
  }
  .BasicInformation_basic-information__left__OFtMI .BasicInformation_cover-img-wrapper__ul7qv {
    height: 150px;
  }
  .BasicInformation_basic-information__right__uzFfa {
    padding: 54px 16px 16px;
  }
  .BasicInformation_basic-information__right__uzFfa .BasicInformation_name__7yLH7 {
    font-size: 18px;
  }
  .BasicInformation_basic-information__right__uzFfa .BasicInformation_sub-name__neZ2V {
    font-size: 12px;
  }
  .BasicInformation_basic-information__left__OFtMI .BasicInformation_cover-img-wrapper__ul7qv {
    height: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/UnitDetail/Components/BasicInformation/BasicInformation.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,2CAAA;EACA,QAAA;AACJ;AACI;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,4BAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,2CAAA;AACN;AAGE;EACE,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,WAAA;AADN;AAGM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AADR;AAME;EACE,YAAA;EACA,kBAAA;AAJJ;AAMI;EACE,YAAA;EACA,aAAA;AAJN;AAQE;EACE,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AANJ;AASE;EACE,uBAAA;EACA,eAAA;AAPJ;AASI;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AAPN;AAWE;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;AATJ;AAWI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AATN;AAaE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAXJ;;AAeA;EAEI;IACE,uBAAA;EAbJ;EAeI;IACE,eAAA;EAbN;EAgBI;IACE,eAAA;EAdN;EAmBI;IACE,aAAA;EAjBN;EA0BE;IACE,uBAAA;EAtBJ;EAwBI;IACE,eAAA;EAtBN;EAyBI;IACE,eAAA;EAvBN;EA4BI;IACE,aAAA;EA1BN;AAbF","sourcesContent":[".basic-information {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  background-color: #f8f8f8;\n  flex-direction: column;\n\n  &__right {\n    width: 100%;\n    padding: 54px 16px 32px;\n    position: relative;\n    background-color: var(--background-color-2);\n    gap: 4px;\n\n    .images-seal-wrapper {\n      overflow: hidden;\n      position: absolute;\n      top: 0;\n      transform: translateY(-84px);\n      padding: 2px;\n      border-radius: 9999px;\n      border: none;\n      background-color: var(--background-color-2);\n    }\n  }\n\n  &__left {\n    align-self: stretch;\n\n    .cover-img-wrapper {\n      height: 280px;\n      width: 100%;\n\n      img {\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  .images-seal-wrapper {\n    padding: 8px;\n    border-radius: 8px;\n\n    .images-seal {\n      width: 119px;\n      height: 118px;\n    }\n  }\n\n  .name {\n    width: fit-content;\n    color: var(--accent-color-dark);\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0;\n    line-height: 1.2;\n  }\n\n  .sub-name {\n    color: var(--dark-grey);\n    font-size: 14px;\n\n    &:hover {\n      color: var(--blue);\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n\n  .bio {\n    margin-top: 10px;\n    color: var(--dark-grey);\n    font-size: 14px;\n\n    &--content {\n      display: -webkit-box;\n      -webkit-line-clamp: 4;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      cursor: pointer;\n    }\n  }\n\n  .more-info {\n    margin-top: 14px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .basic-information {\n    &__right {\n      padding: 54px 16px 16px;\n\n      .name {\n        font-size: 18px;\n      }\n\n      .sub-name {\n        font-size: 12px;\n      }\n    }\n\n    &__left {\n      .cover-img-wrapper {\n        height: 150px;\n      }\n    }\n  }\n}\n\n\n@media only screen and (max-width: 900px) {\n  .basic-information {\n    &__right {\n      padding: 54px 16px 16px;\n\n      .name {\n        font-size: 18px;\n      }\n\n      .sub-name {\n        font-size: 12px;\n      }\n    }\n\n    &__left {\n      .cover-img-wrapper {\n        height: 150px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basic-information": `BasicInformation_basic-information__WRrm+`,
	"basic-information__right": `BasicInformation_basic-information__right__uzFfa`,
	"images-seal-wrapper": `BasicInformation_images-seal-wrapper__nfXxR`,
	"basic-information__left": `BasicInformation_basic-information__left__OFtMI`,
	"cover-img-wrapper": `BasicInformation_cover-img-wrapper__ul7qv`,
	"images-seal": `BasicInformation_images-seal__wTit+`,
	"name": `BasicInformation_name__7yLH7`,
	"sub-name": `BasicInformation_sub-name__neZ2V`,
	"bio": `BasicInformation_bio__o5J-X`,
	"bio--content": `BasicInformation_bio--content__Nx0Rb`,
	"more-info": `BasicInformation_more-info__ZabQu`
};
export default ___CSS_LOADER_EXPORT___;
